export enum CustomerType {
  Private = "private",
  Business = "business",
}
